import Vue from 'vue'

export default new Vue({
    name: 'event-bus'
})



// WEBPACK FOOTER //
// ./src/components/framework/data-grid/bus.js